import { showControlTypeName } from '@/utils/control_type'
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Col, Row, Button, Image } from 'antd'
import cx from 'classnames'
import './../Checkpoints.style.less'
import { eventBus } from '@/utils/eventBus'
import { MITT_EVENT_BUS } from '@/constant/common'
import ChatButton from '@/components/ChatButton/ChatButton'
import { filter, find, flatMap, get, includes, map, size } from 'lodash'
import { InspectionStatus } from '@/constant/qsf'
import InspectionCommentListComponent from '@/components/InspectionCommentListComponent'

const { INSPECTION_REPORT_COMMENT } = MITT_EVENT_BUS
const { NEEDS_REVISIONS, UNDER_REVIEW } = InspectionStatus

type Props = {
  data: any
  editable: boolean
  onEditPhoto: (key: number) => void
  onAddPhoto: () => void
  section: {
    section: any
    sectionIndex: number
  }
  subSection: {
    subSection: any
    subSectionIndex: number
  }
  checkpoint?: any
  options?: any
}

function ControlTypePhoto({
  data,
  editable,
  onEditPhoto,
  onAddPhoto,
  section,
  subSection,
  checkpoint,
  options,
}: Props) {
  const inspectionRound = get(options, 'inspectionRound')
  const checkpointIndex = get(options, 'checkpointIndex')
  const inspectionStatus = get(options, 'inspectionStatus')
  const isInvitedAsReviewer = get(options, 'isInvitedAsReviewer')
  const sectionsComments = get(options, 'inspectionCommentsData.sections')
  const filterSectionWithTasks = flatMap(
    map(
      filter(sectionsComments, (item) => size(item.tasks)),
      'tasks'
    )
  )

  const commentOnTask = find(
    filterSectionWithTasks,
    (item) => item.id === data.id
  )

  const sizeComment = !!size(get(commentOnTask, 'comments', []))

  const Comment = () => {
    eventBus.emit(INSPECTION_REPORT_COMMENT, {
      selectedSubSection: subSection,
      selectedSection: section,
      selectedCheckpoint: {
        checkpoint: data,
        checkpointIndex: checkpointIndex,
      },
    })
  }

  const isNewCheckpointRound = get(checkpoint, 'round') === inspectionRound

  const renderCommentCheckpoint = () => {
    let resultContent = null

    if (includes([UNDER_REVIEW, NEEDS_REVISIONS], inspectionStatus)) {
      if (isInvitedAsReviewer) {
        const { generatingReportAtom } = options
        resultContent = (
          <ChatButton
            isHidden={generatingReportAtom?.isGenerating}
            redPoint={isNewCheckpointRound}
            onClick={Comment}
            chatCount={checkpoint.comment_counter}
          />
        )
      }
    }

    return resultContent
  }
  return (
    <Col
      span={data.value.length > 1 ? 24 : 12}
      className={cx(
        'control-type-photo-container',
        data.value.length > 1 ? '' : 'flex-49-percent',
        data.value.length < 3 ? 'page-break-inside' : ''
      )}
    >
      <Row justify={'space-between'}>
        <p className="label">{showControlTypeName(data)}</p>
        {renderCommentCheckpoint()}
      </Row>

      {sizeComment && (
        <Row className="comment-report-container">
          <InspectionCommentListComponent
            dataSource={commentOnTask}
            displayType="checkpoint"
          />
        </Row>
      )}

      <Row justify={'space-between'}>
        {data?.value &&
          data.value.map((item, key) => {
            return (
              <Col
                span={data.value.length > 1 ? 12 : 24}
                className={cx(
                  'image-container',
                  data.value.length > 1 ? 'flex-49-percent ' : ''
                )}
                key={key}
              >
                <Image
                  className="control-type-photo"
                  style={{ objectFit: 'contain' }}
                  src={item.media}
                />
                <Row>
                  <p>{item.comment}</p>
                  {editable && (
                    <Button
                      className="edit-button"
                      onClick={() => onEditPhoto(key)}
                      icon={<EditOutlined />}
                    />
                  )}
                </Row>
              </Col>
            )
          })}
        {editable && (
          <Button
            className="add-photo-button"
            onClick={() => onAddPhoto()}
            icon={<PlusOutlined />}
          >
            Add Photo
          </Button>
        )}
      </Row>
    </Col>
  )
}

export default ControlTypePhoto
